module.exports = __webpack_public_path__ + "img/Kim.7d50b252.jpeg";